import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { ReactSVG } from 'react-svg';
import UIButton from 'Components/UIComponents/UIButton';
import { AuthorizedRoutePaths } from 'Interfaces/RoutePaths';

import AppSumoLogo from 'Assets/images/icons/appsumo.svg';
import PlusLogo from 'Assets/images/icons/plus.svg';
import SignaturelyLogo from 'Assets/images/logo.svg';

const AppSumoThanks = () => {
  const navigate = useNavigate();

  const navigateToRoot = useCallback(() => {
    navigate(AuthorizedRoutePaths.BASE_PATH, { replace: true });
  }, [navigate]);

  return (
    <div className="appsumo">
      <div className="appsumo__container">
        <div className="appsumo__logo-container">
          <ReactSVG src={SignaturelyLogo} className="appsumo__logo" />
          <ReactSVG src={PlusLogo} className="appsumo__logo appsumo__logo-plus" />
          <ReactSVG src={AppSumoLogo} className="appsumo__logo" />
        </div>
        <h1 className="appsumo__header">
          Thanks for registering to the AppSumo promotion.
        </h1>
        <p className="appsumo__text">
          We are very excited to have you on board! Welcome to the team.
        </p>
        <div className="team__accept-button">
          <UIButton
            priority="primary"
            title="Start using Signaturely"
            handleClick={navigateToRoot}
          />
        </div>
      </div>
    </div>
  );
};

export default AppSumoThanks;
